import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import apiClient from '../../_utils/axios';
import { useHomePageContext } from '../../context/HomePageContext';
import { getStringByLang } from '../../libs/lang';
import { BlockMore, BlockTitle } from '../HomePage';
import RenderThumbs from './renderThumbs';

export const BestDesign = ({ interest_list, ShowBasketModal, setStateAsync }) => {
  const { state } = useHomePageContext();
  const [data, setData] = useState([]);
  const history = useHistory();

  const onGoBest = () => {
    history.push('/design/all/all?sort=order_count&order=descend');
  };

  const onGoFavori = () => {
    history.push(`/mypage/purchase/favori`);
  };

  const getBestDesign = async () => {
    try {
      const res = await apiClient.get(`/web/product?&page=1&size=15&sort=order_count&order=descend`);
      if (res) {
        setData(res.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch new design list:', error);
    }
  };

  const reSetData = async (newData) => {
    setData([...newData]);
  };

  useEffect(() => {
    getBestDesign();
  }, []); // Runs once when the component mounts

  const renderedTitle = useMemo(() => {
    return getStringByLang(state.config.main_title_3_ko, state.config.main_title_3_en, state.config.main_title_3_jp);
  }, [state.config]);

  const renderedThumbs = useMemo(() => {
    return (
      <RenderThumbs
        thumbList={data}
        interest_list={interest_list}
        largeCount={15}
        middleCount={12}
        middleSmallCount={6}
        mallCount={6}
        setData={reSetData}
        main_title={renderedTitle}
        onGoFavori={onGoFavori}
        ShowBasketModal={ShowBasketModal}
        setStateAsync={setStateAsync}
      />
    );
  }, [data, interest_list, renderedTitle]);

  const currentTitle = getStringByLang(
    state.config.main_title_3_ko,
    state.config.main_title_3_en,
    state.config.main_title_3_jp,
  );

  return (
    <div style={{ marginTop: '7vw' }}>
      <BlockTitle>{currentTitle}</BlockTitle>
      <BlockMore onClick={onGoBest} />
      {renderedThumbs}
    </div>
  );
};

export default BestDesign;
